import styled from 'styled-components';
import { CFBaseSelectFieldStyles, } from '@connectrn/ds-ui-base';
export const CFSelectFieldElements = {
    SelectFieldFlyout: styled.div `
    ${CFBaseSelectFieldStyles.SelectFieldFlyout}
  `,
    SelectFieldFlyoutDismiss: styled.button `
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 1;
    border: 0;
    background: transparent;
  `,
    SelectFieldOptionList: styled.div `
    ${CFBaseSelectFieldStyles.SelectFieldOptionList}
    ${CFBaseSelectFieldStyles.SelectFieldOptionListWeb}
  `,
    SelectFieldOptionListLabel: styled.span `
    ${CFBaseSelectFieldStyles.SelectFieldOptionListLabel}
  `,
    SelectFieldOptionsWrapper: styled.div `
    ${CFBaseSelectFieldStyles.SelectFieldOptionsWrapper}
  `,
};
